
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function FinalCTASection() {
  const navigate = useNavigate();

  const handleJoinWaitlist = () => {
    navigate('/app');
  };

  const handleSponsorFamily = () => {
    navigate('/donate');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div 
          className="relative rounded-3xl overflow-hidden"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/fb77c917669d9c217b411c233a215371.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-[#12B6B6]/90"></div>
          
          {/* Content */}
          <div className="relative z-10 text-center py-20 px-8">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                We are building a future where oxygen is understood, protected, and accessible to all.
              </h2>
              <p className="text-xl text-white/90 mb-10 leading-relaxed">
                Join thousands of individuals, families, and organizations working 
                towards a world where everyone has access to oxygen health knowledge and care.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
                <Button 
                  variant="secondary" 
                  size="lg" 
                  className="px-10 bg-white text-[#12B6B6] hover:bg-gray-100"
                  onClick={handleJoinWaitlist}
                >
                  Join the App Waitlist
                </Button>
                <Button 
                  variant="outline" 
                  size="lg" 
                  className="px-10 border-white text-white hover:bg-white hover:text-[#12B6B6]"
                  onClick={handleSponsorFamily}
                >
                  Sponsor a Family
                </Button>
              </div>
              
              {/* Impact Counter */}
              <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto">
                <div className="text-center">
                  <div className="text-3xl font-bold text-white">₹2,500</div>
                  <div className="text-white/80 text-sm">Will sponsor 1 family's complete care</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white">₹5,000</div>
                  <div className="text-white/80 text-sm">Will cover 2 families with OxyKits</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white">₹10,000</div>
                  <div className="text-white/80 text-sm">Will provide comprehensive support for 2 families</div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        
        {/* Trust Indicators */}
        <div className="mt-12 text-center">
          <div className="flex flex-wrap justify-center items-center gap-8 text-sm text-gray-600">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-green-600"></i>
              <span>Section-8 Non-Profit</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-file-shield-line w-4 h-4 flex items-center justify-center text-blue-600"></i>
              <span>80G Tax Exemption</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-pie-chart-line w-4 h-4 flex items-center justify-center text-purple-600"></i>
              <span>Transparent Impact Reports</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-government-line w-4 h-4 flex items-center justify-center text-orange-600"></i>
              <span>Government Partnerships</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
